import marka from '@components/search/inputs/markaTrailer'
import model from '@components/search/inputs/modelNone'
import cena from '@components/search/inputs/cena'
import stan from '@components/search/inputs/stan'
import rata from '@components/search/inputs/rata'
import waga from '@components/search/inputs/waga'
import typ from '@components/search/inputs/typTrailer'
import rocznik from '@components/search/inputs/rocznik'
import lokalizacja from '@components/search/inputs/lokalizacjaZasieg'
import liczbaOsi from '@components/search/inputs/liczbaOsi'

import krajPochodzenia from '@components/search/inputsAdvanced/krajPochodzenia'
import stanPojazdu from '@components/search/inputsAdvanced/stanPojazdu'
import rodzajSprzedazy from '@components/search/inputsAdvanced/rodzajSprzedazy'
import nadwozie from '@components/search/inputsAdvanced/nadwoziePrzyczepa'
import dodatkoweWyposazenie from '@components/search/inputsAdvanced/dodatkoweWyposazeniePrzyczepy'

const trailerFormInputs = [
    marka,
    cena,
    stan,
    model,
    rata,
    waga,
    typ,
    rocznik,
    lokalizacja,
]

const trailerAdvancedInputs = [
    krajPochodzenia,
    liczbaOsi,
    stanPojazdu,
    rodzajSprzedazy,
    nadwozie,
    dodatkoweWyposazenie,
]

const trailerFormInputsMobile = [
    marka,
    model,
    typ,
    rocznik,
    cena,
    { type: 'blank' },
]

const trailerAdvancedInputsMobile = [
    lokalizacja,
    stan,
    ...trailerAdvancedInputs,
]

export {
    trailerFormInputs,
    trailerAdvancedInputs,
    trailerFormInputsMobile,
    trailerAdvancedInputsMobile,
}